import { colors } from "@/theme";
import { useEffect, useRef, useState } from "react";
import useMobileView from "@/hooks/useMobileView";
import {Box, Card, ScrollArea} from "@mantine/core";

export default function ScContainerResponsive({ children }: any) {

    return (<>
        <Box
            bg={'gray.2'}
            mih={'calc(100dvh - 20px)'}
        >
            <Card
                style={{
                    paddingInlineEnd: 'var(--mantine-spacing-sm)',
                    minHeight: 'calc(100dvh - 20px)',
                    maxWidth: 1100,
                    marginInline: 'auto'
                    // width: '100%',
                }}
                bg={'transparent'}
            >
                <ScrollArea
                >
                    {children}
                </ScrollArea>
            </Card>
        </Box>
    </>);
}